// What is left of the Add client form's mock choices. Everything the backend
// keeps a reference list for has moved to `catalogService` — title, goal,
// dietary pattern, allergen and life style all come from the API now, so a
// saved client carries the backend's own id rather than a matching string.
//
// These two are the ones with no endpoint behind them yet. Both go the moment
// one lands, the same way the others did.

export const GENDER_OPTIONS = ["Male", "Female", "Other"];

export const PROFESSION_OPTIONS = [
  "Working",
  "Self employed",
  "Student",
  "Homemaker",
  "Retired",
];

// State and city are not here either: they come from `lib/locations`, the same
// real dataset the brand address uses, narrowed to the state picked above them.
